import "./SubscriptionExpired.css";
import { useNavigate } from "react-router-dom";
export default function SubscriptionExpired() {
  const navigate = useNavigate();
  return (
    <div className="expired-page">
      <div className="expired-card">
        <h1>🚫 Subscription Expired</h1>

        <p>Your gym subscription has expired.</p>

        <p>
          Please renew your subscription to continue using the Gym SaaS
          platform.
        </p>

        <button className="renew-btn" onClick={() => navigate("/Subscription")}>
          Renew Subscription
        </button>
      </div>
    </div>
  );
}
